import { useTranslation } from "Shared/util/custom-hooks";
import makeComponentTrashable from "trashable-react";
import InputCheckbox from "Shared/components/input-checkbox";
import { funcFilterStatus } from "Shared/util/translations";
import styles from "./export-transactions-options.css";

const ExportTransactionsOptions = ({
    enabledExportOptions,
    selectedExportOption,
    setSelectedExportOption,
    handleExportOptionClick,
}) => {
    const t = useTranslation((x) => x.export);

    const isExportOptionChecked = (option) =>
        selectedExportOption.description === option.description;

    return (
        <>
          <div className={styles.formatOptions}>
            {Object.keys(enabledExportOptions)
              .map((option) => (
                <div
                  key={option}
                  className={styles.formatOption}
                  onClick={() => setSelectedExportOption(enabledExportOptions[option])}
                >
                  <InputCheckbox
                    checked={isExportOptionChecked(enabledExportOptions[option])}
                    onChange={() => handleExportOptionClick(enabledExportOptions[option])}
                    className={styles.customCheckbox}
                  />
                  <div className={styles.formatOptionText}>
                    <div className={styles.formatOptionTitle}>{funcFilterStatus(enabledExportOptions[option], t, 'title').title}</div>
                    <div className={styles.formatOptionDescription}>{enabledExportOptions[option].description}</div>
                  </div>
                </div>
              ))}
          </div>
        </>
    );
};

export default makeComponentTrashable(ExportTransactionsOptions);
